<template>
  <div>
    <canvas id="myChart" class="img-chart"></canvas>
  </div>
</template>
<script>
export default {
  props: {
    glabels: {
      type: Object,
      default: {}
    }
  },
  data: () => ({}),
  methods: {
    createdchart() {
      var vm = this
      const jsonData = JSON.parse(JSON.stringify(this.glabels))
      if (myDoughnutChart) {
        myDoughnutChart.destroy()
      }
      var ctx = document.getElementById('myChart')
      var myDoughnutChart = new Chart(ctx, {
        type: 'pie',
        data: jsonData,
        options: {
          legend: false,
          scaleShowLabels: false,
          maintainAspectRatio: false,
          responsive: false
        }
      })

      myDoughnutChart.data = jsonData // Would update the first dataset's value of 'March' to be 50
      myDoughnutChart.update()
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.createdchart()
    })
  },
  watch: {
    glabels: {
      deep: true,
      handler() {
        this.createdchart()
      }
    }
  }
}
</script>
